<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <b-icon icon="tasks" class="m-2"></b-icon>
        Détail pour {{ detailSalarie.salarie }}
      </p>
    </header>
    <section class="modal-card-body">
      <div class="has-text-centered">
        <br />

        <div class="columns">
          <div class="column is-one-quarter">
            <h1 class="title">Activité</h1>
            {{ detailSalarieGrandtotal }} jours
            <em>(dont {{ detailSalarie.surmarge }} jours sur marges)</em> sur
            {{ detailSalarie.daystospend }}
            <b-progress
              :type="[
                {
                  'is-danger':
                    detailSalarieGrandtotal / detailSalarie.daystospend < 0.8,
                },
                {
                  'is-warning':
                    detailSalarieGrandtotal / detailSalarie.daystospend < 0.99,
                },
                {
                  'is-success':
                    detailSalarieGrandtotal / detailSalarie.daystospend <= 1.01,
                },
                {
                  'is-info':
                    detailSalarieGrandtotal / detailSalarie.daystospend > 1.01,
                },
              ]"
              :value="
                Math.round(
                  (detailSalarieGrandtotal / detailSalarie.daystospend) * 100
                )
              "
              show-value
              size="is-large"
            >
              Activité financée à
              {{
                Math.round(
                  (detailSalarieGrandtotal / detailSalarie.daystospend) * 100
                )
              }}
              %
            </b-progress>

            <h1 class="title">Importance de chaque dossier</h1>
            <canvas id="chart1" responsive> </canvas>
          </div>

          <div class="column is-three-quarters">
            <h1 class="title">Activité par dossier et phases</h1>
            <b-table
              :data="detailSalarie.table"
              ref="table"
              detailed
              hoverable
              custom-detail-row
              detail-key="project"
              show-detail-icon
            >
              <b-table-column
                field="name"
                label="Projet et phase"
                v-slot="props"
              >
                <b>{{ props.row.project }}</b>
              </b-table-column>

              <b-table-column
                field="delta"
                label="Nombre de jours à passer"
                sortable
                v-slot="props"
              >
                <b>{{ props.row.sum }}</b>
              </b-table-column>

              <b-table-column field="comment" label="Tâche" sortable>
                <b>-</b>
              </b-table-column>

              <template slot="detail" slot-scope="props">
                <tr v-for="item in props.row.phases" :key="item.phase">
                  <td></td>
                  <td class="">
                    {{ item.phase }}
                  </td>
                  <td class="">
                    {{ item.days }}
                  </td>
                  <td class="">
                    {{ item.comment }}
                  </td>
                </tr>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Quitter
      </button>
      <button class="button" type="button" @click="toCSV()">
        Export en CSV
      </button>
    </footer>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import Palette from "google-palette";

export default {
  name: "ChargeSalarie",
  props: {
    detailSalarie: {
      required: true,
    },
  },
  computed: {},
  mounted() {
    // Ajout des marges au total des jours sur projets
    this.detailSalarieGrandtotal =
      this.detailSalarie.grandtotal + this.detailSalarie.surmarge;
    this.test();
  },
  methods: {
    toCSV() {
      let str = "";
      str += `Salarié = ${this.detailSalarie.salarie}\r\n`;
      str += `Total jours = ${this.detailSalarieGrandtotal}\r\n\r\n`;
      this.detailSalarie.table.forEach((project) => {
        str += `${project.project}\t${project.sum}\r\n`;
        project.phases.forEach((phase) => {
          str += `\t\t${phase.phase}\t${phase.days}\r\n`;
        });
        str += "\r\n";
      });

      const url = window.URL.createObjectURL(
        new Blob([str], { type: "text/csv" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${this.detailSalarie.salarie}.csv`);
      document.body.appendChild(link);
      link.click();
    },
    test() {
      let colors = Palette("mpn65", this.detailSalarie.graph.label.length);
      for (let i = 0; i < colors.length; i++) {
        colors[i] = "#" + colors[i];
      }

      let data = {
        datasets: [
          {
            data: this.detailSalarie.graph.value,
            backgroundColor: colors,
          },
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: this.detailSalarie.graph.label,
      };
      const ctx = document.getElementById("chart1");
      new Chart(ctx, {
        type: "pie",
        data: data,
        options: {
          legend: {
            display: false,
          },
        },
      });
    },
  },
  data() {
    return {
      detailSalarieGrandtotal: 0,
    };
  },
};
</script>

<style scoped></style>
